import { selectionIsInNode } from '@common/prosemirror/state/selection';
import { NodeToolbarPopupPluginViewComponent } from '@portal-core/text-editor/plugin-views/components/node-toolbar-popup-plugin-view/node-toolbar-popup-plugin-view.component';
import { ToolbarPopupPluginViewBase } from '@portal-core/text-editor/plugin-views/toolbar-popup.plugin-view.base';
import { ElementOverlayService } from '@portal-core/ui/overlay/services/element.overlay.service';
import { EditorState, NodeSelection } from 'prosemirror-state';
import { EditorView } from 'prosemirror-view';
import { Observable } from 'rxjs';

export interface NodeToolbarPopupPluginOptions {
  onEdit?: (src: string) => void;
  onOpen?: (src: string) => void;
  isEditable: (src: string) => boolean;
  isReadonly$: Observable<boolean>;
}

export class NodeToolbarPopupPluginView extends ToolbarPopupPluginViewBase<NodeToolbarPopupPluginViewComponent> {
  private nodeSrc: string;
  private options: NodeToolbarPopupPluginOptions;

  constructor(elementOverlayService: ElementOverlayService, options: NodeToolbarPopupPluginOptions) {
    super(NodeToolbarPopupPluginViewComponent, elementOverlayService, options.isReadonly$);

    this.options = options;
  }

  updateComponent(editorView: EditorView, prevEditorState: EditorState) {
    if (this.isReadonly) {
      return;
    }
    const selection = editorView.state.selection as NodeSelection;

    // Find a valid node type that the selection is within
    const isInSnippet = selectionIsInNode(selection, editorView.state.schema.nodes.madcapsnippettext) || selectionIsInNode(selection, editorView.state.schema.nodes.madcapsnippetblock);

    if (isInSnippet) {
      this.nodeSrc = selection.node.attrs.src;

      this.component.isEditable = this.nodeSrc ? this.options.isEditable(this.nodeSrc) : false;
      const nodeRect = (editorView as any).lastSelectedViewDesc?.nodeDOM?.getBoundingClientRect();
      const popupMarginTop = 2;
      const popupArrowHeight = 7;

      const popupLeft = nodeRect.left;
      const popupTop = nodeRect.bottom + popupMarginTop + popupArrowHeight;

      this.component.openPopup(popupLeft, popupTop);
    } else {
      this.component.closePopup();
    }
  }

  onComponentCreated() {
    super.onComponentCreated();
    this.subscriptions.add(this.component.openNode.subscribe(this.onOpenNode.bind(this)));
    this.subscriptions.add(this.component.editNode.subscribe(this.onEditNode.bind(this)));
  }

  onEditNode() {
    this.options.onEdit(this.nodeSrc);
  }

  onOpenNode() {
    this.options.onOpen(this.nodeSrc);
    this.closePopup();
  }
}
